<template>
  <div class="MiroPicker">
    <v-alert
      v-if="error"
      :value="true"
      severity="error"
      class="miro-picker-error"
    >
      {{ error }}
    </v-alert>
    <v-row>
      <v-col
        v-for="(board, index) in boards"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <miro-card :board="board" :onSelect="onSelect" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Parse from 'parse'
import MiroCard from './MiroCard'
export default {
  props: {
    token: String,
    onSelect: Function,
  },
  components: {
    MiroCard,
  },
  data() {
    return {
      boards: [],
      error: '',
      isLoading: true,
    }
  },
  created() {
    // Don't call onInitLoad here, wait for token prop
  },
  watch: {
    token: {
      immediate: true,
      handler(newToken) {
        if (newToken) {
          this.onInitLoad()
        }
      }
    }
  },
  methods: {
    async onInitLoad() {
      if (!this.token) {
        this.error = 'No Miro access token provided'
        this.isLoading = false
        return
      }

      // Check if this looks like an authorization code (base64 encoded, contains dots)
      if (this.token.includes('.') && this.token.length > 50) {
        console.warn('Token appears to be an authorization code, not an access token')
        this.error = 'Invalid token format - received authorization code instead of access token'
        this.isLoading = false
        return
      }

      try {
        const res = await Parse.Cloud.run('getAllBoards', { token: this.token })
        
        if (res.status === 'success') {
          // The cloud code returns res.boards.data, not res.result.data
          this.boards = res.boards?.data || []
          this.error = ''
        } else {
          this.error = res.message || 'Failed to load Miro boards'
        }
      } catch (e) {
        console.error('Error retrieving Miro boards:', e)
        this.error = e.message || 'Failed to connect to Miro API'
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
